import React from "react";
import { Field } from "react-final-form";
import BootstrapInput from "../../../../../../../components/BootstrapInput";

export default function Parent() {

  return (
    <>
      <Field
        required
        fullWidth
        type="text"
        name="name"
        label="Full Name"
        placeholder="Full Name"
        component={BootstrapInput}
      />
    </>
  );
}
